import { apiService } from './index';

// Inport types
import { ISelect, Product } from '../shared/types/shared';
import { ProductHistorical } from '../shared/types/systemConfiguration/products';

export const asyncGetProducts = async (filters: {
    applyPqr?: boolean;
    applyEscalations?: boolean;
}): Promise<ISelect[]> => {
    try {
        if (!filters.applyPqr) delete filters.applyPqr;
        if (!filters.applyEscalations) delete filters.applyEscalations;

        const products: ISelect[] = await apiService.get(
            `/api/product`,
            filters
        );

        return products || [];
    } catch (error) {
        return [];
    }
};

export const asyncGetProductsFilters = async (
    filters?: Product,
    page?: number,
    pageSize?: number
): Promise<{ items: Product[]; length: number }> => {
    try {
        const {
            items: data,
        }: {
            items: { items: Product[]; length: number };
        } = await apiService.get(`/api/product/filters`, {
            limit: pageSize || 20,
            page: page || 0,
            ...filters,
        });

        return data || { items: [], length: 0 };
    } catch (error) {
        return { items: [], length: 0 };
    }
};

export const asyncGetProduct = async (
    idProduct: string
): Promise<Product | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: Product;
        } = await apiService.get(`/api/product/${idProduct}`);
        return data;
    } catch (error) {}
};

export const asyncGetProductHistorical = async (
    idProduct: string
): Promise<ProductHistorical[] | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: ProductHistorical[];
        } = await apiService.get(`/api/product/${idProduct}/historical`);
        return data;
    } catch (error) {}
};

export const asyncUpdateProduct = async (
    id: string,
    product: Product
): Promise<Product | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: Product;
        } = await apiService.patch(`/api/product/${id}`, product);
        return data;
    } catch (error) {}
};

export const asyncCreateProduct = async (
    info: Product
): Promise<Product | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: Product;
        } = await apiService.post('/api/product', info);
        return data;
    } catch (error) {}
};
